// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".90179f9febd8bf26f5482bce4a01eadd0b617bb0.chunk.js";
};